module.exports = __webpack_public_path__ + "static/media/bed-empty.3a839a72.svg";